import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import WhoWeServe from './pages/WhoWeServe'
import Careers from './pages/Careers'
import AreasWeServe from './pages/AreasWeServe'
import Contact from './pages/Contact'

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-stone-50" data-component-path="client/src/App.jsx" data-component-line="1:1" data-component-id="client/src/App.jsx:1:1">
        <Navbar />
        <main className="flex-grow" data-component-path="client/src/App.jsx" data-component-line="2:2" data-component-id="client/src/App.jsx:2:2">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/who-we-serve" element={<WhoWeServe />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/areas-we-serve" element={<AreasWeServe />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </Router>
  )
}

export default App